import React, { useState, useEffect } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { motion } from "framer-motion";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import { images } from "../../constants";
import { Link } from "react-scroll";
import "./Testimonial.scss";

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [brands, setBrands] = useState([]);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  const getImageSrc = (testimonial) => {
    try {
      if (testimonial.imgUrl && testimonial.imgUrl.asset) {
        return urlFor(testimonial.imgUrl);
      }
      return images.userEmpty;
    } catch (error) {
      return images.userEmpty;
    }
  };

  useEffect(() => {
    const query =
      '*[_type == "testimonials" && approved == true] | order(_createdAt desc){name, company, feedback, imgUrl}';
    const brandsQuery = '*[_type == "brands"]{_id, name, imgUrl}';

    client.fetch(query).then((data) => {
      setTestimonials(data);
    });

    client.fetch(brandsQuery).then((data) => {
      setBrands(data);
    });
  }, []);

  return (
    <>
      <div
        className="testimonial-cta"
        style={{ margin: "2rem 0", textAlign: "center" }}
      >
        <p style={{ fontSize: "1.2rem", marginBottom: "1rem" }}>
          Have something to say? We'd love to hear your feedback!
        </p>
        <Link to="app__contact-cta" smooth={true} duration={500} offset={-70}>
          <button
            style={{
              padding: "0.7rem 2rem",
              fontSize: "1rem",
              background: "var(--gray-color)",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Submit Feedback
          </button>
        </Link>
      </div>
      {testimonials.length && (
        <>
          <div className="app__testimonial-item app__flex">
            <img
              src={getImageSrc(testimonials[currentIndex])}
              alt={testimonials[currentIndex].name}
            />
            <div className="app__testimonial-content">
              <FaQuoteRight className="app__testimonial-quote" />
              <p className="p-text">{testimonials[currentIndex].feedback}</p>
              <div>
                <h4 className="bold-text">{testimonials[currentIndex].name}</h4>
                <h5 className="p-text">{testimonials[currentIndex].company}</h5>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex">
            <div
              className="app__flex"
              onClick={() =>
                handleClick(
                  currentIndex === 0
                    ? testimonials.length - 1
                    : currentIndex - 1
                )
              }
            >
              <HiChevronLeft />
            </div>

            <div
              className="app__flex"
              onClick={() =>
                handleClick(
                  currentIndex === testimonials.length - 1
                    ? 0
                    : currentIndex + 1
                )
              }
            >
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      <div className="app__testimonial-brands app__flex">
        {brands.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: "tween" }}
            key={brand._id}
          >
            <img src={urlFor(brand.imgUrl)} alt={brand.name} />
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, "app__testimonial"),
  "testimonial",
  "app__primarybg"
);
